/**
 * URL-hash keys for the sticking feature's deep-linkable overlays, bound via
 * `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the entity id as a hash param (`#actions/5`).
 */
export const STICKING_HASH = {
  /** `#actions/<id>` — StickingActionsDialog for a specific container. */
  actions: 'actions',
  /** `#qr/<id>` — QrDataDialog viewing print/QR data for a container. */
  qr: 'qr',
  /** `#scan` — camera QR scan dialog (listing). */
  scan: 'scan'
} as const;

export type StickingHashKey =
  (typeof STICKING_HASH)[keyof typeof STICKING_HASH];
